export default __webpack_public_path__ + "QuentinBICHI.c81bf76.png";